// SHARED
import Spinner from '@/views/elements/spinner.vue'
import TablePaginator from '@/views/elements/table-paginator.vue'
import ApiImg from '@/views/elements/api-img.vue'
import ApiImgPristine from '@/views/elements/api-img-pristine.vue'
import autoForm from '@/views/elements/auto-form.vue'
import noCardTablePaginator from '@/views/elements/no-card-table-paginator.vue'
import uiEditAutoModal from '@/views/elements/ui-edit-auto-modal.vue'
import quickFetchingCard from '@/views/elements/quick-fetching-card.vue'

function plugin (Vue) {
  // SHARED
  Vue.component('uiEditAutoModal', uiEditAutoModal)
  Vue.component('spinner', Spinner)
  Vue.component('apiImg', ApiImg)
  Vue.component('cPaginate', TablePaginator)
  Vue.component('autoForm', autoForm)
  Vue.component('tPaginate', noCardTablePaginator)
  Vue.component('quickFetchingCard', quickFetchingCard)
  Vue.component('ApiImgPristine', ApiImgPristine)
}

export default plugin
